/* eslint-disable camelcase */

// extract the values from the object `values`, only from `names` if given.
// extract({ foo: 1, bar: 2}) => [1, 2]
// extract({ foo: 1, bar: 2}, ['foo', 'baz']) => [1]
const extract = (values, names) => names
	? names.map(name => values[name]).filter(Boolean)
	: Object.values(values);

// Aggregate all the conversions into a single sum
const sumConversions = conversions => conversions.length === 1
	? conversions[0]
	: conversions.reduce((accumulator, value) => {
		accumulator.count += value.count;
		accumulator.ca_ht += value.ca_ht;
		accumulator.ca_ttc += value.ca_ttc;
		accumulator.commissions += value.commissions;
		accumulator.tickets += value.tickets;
		return accumulator;
	}, {
		count: 0,
		ca_ht: 0,
		ca_ttc: 0,
		commissions: 0,
		tickets: 0
	});

// takes a list of list, flatten it, generate a set to isolate unique elements, and cast to array
const unique = (valuesList) => Array.from(new Set(valuesList));

class DataConversion {
	constructor({
		count,
		ca_ttc,
		ca_ht,
		commissions,
		tickets,
	} = {}, currency, mediums) {
		this._count = count || 0;
		this._ttc = ca_ttc || 0;
		this._ht = ca_ht || 0;
		this._commissions = commissions || 0;
		this._tickets = tickets || 0;
		this._currency = currency;
		this._mediums = mediums;
	}

	getCurrency() {
		return this._currency;
	}

	getMediums() {
		return this._mediums;
	}

	getCount() {
		return this._count;
	}

	getRevenueWithTaxes() {
		return this._ttc / 100;
	}

	getRevenueWithoutTaxes() {
		return this._ht / 100;
	}

	getCommissions() {
		return this._commissions;
	}

	getTickets() {
		return this._tickets;
	}
}

export default class Conversion {
	constructor({
		conversions,
		organization,
		campaign
	}) {
		this._conversions = conversions || {};
		this._campaign = campaign || {};
		this._organization = organization || {};
	}

	getKey() {
		return this._organization.id || this._campaign.id;
	}

	getOrganizationId() {
		return this._organization.id;
	}

	getOrganizationName() {
		return this._organization.name;
	}

	getCurrency() {
		for(let utm_source in this._conversions) {
			for (let utm_medium in this._conversions[utm_source]) {
				return this._conversions[utm_source][utm_medium].currency;
			}
		}
	}

	getWeezTargetConversion(options={}) {
		return this.getAllConversions({ ...options, sources: ['WeezTarget', 'weeztarget'] });
	}

	getAllConversions({ sources, mediums, currency }={}) {
		// Select the default currency
		currency = currency || this.getCurrency();
		// Extract from the conversions the sources by name
		const _sources = extract(this._conversions, sources);
		mediums = mediums || unique(_sources
			.map(medium => Object.keys(medium))
			.flat());

		// From each source, extract the mediums by name and aggregate all conversions
		const conversions = _sources
			.map(source => extract(source, mediums))
			.map(conversions => conversions.filter((value) => value.currency === currency))
			.map(sumConversions);
		// instanciate the DataConversion with the aggregation of the values
		return new DataConversion(sumConversions(conversions), currency, mediums);
	}
}
